import { useState, FC } from 'react';
import { Add } from '@mui/icons-material';
import { Box, Button, MenuItem } from '@mui/material';
import { SectionTypeValue, IDropdownResponse, ICustomPageSection } from '../../../models';
import { DEFAULT_SECTION } from './ManageCustomPage';
import { getRandomNegativeNumber } from '../../../helpers';
import { SMBSelect } from '../../../components';

interface ISectionTypeSelector {
  sectionTypes: IDropdownResponse[];
  selectedSectionType?: string;
  handleAddSectionType: (val: ICustomPageSection) => void;
}

export const SectionTypeSelector: FC<ISectionTypeSelector> = ({
  sectionTypes,
  selectedSectionType,
  handleAddSectionType
}) => {
  const [selectedType, setSelectedType] = useState<SectionTypeValue | string>(
    selectedSectionType ?? ''
  );
  return (
    <Box display="flex" flexDirection={{ xs: 'column', sm: 'row' }}>
      <SMBSelect
        name="type"
        variant="outlined"
        label="Section Type"
        handleClear={() => setSelectedType('')}
        id="type"
        value={selectedType}
        onChange={({ target: { value } }) => setSelectedType(value as SectionTypeValue)}
      >
        {/* Filter out sectionTypes for unused sections or subsection components that are only used within specific section types */}
        {sectionTypes
          ?.filter(
            type =>
              type.value !== 'Footer' &&
              type.value !== 'GenericSection' &&
              type.value !== 'AccordionItem' &&
              type.value !== 'ButtonLink' &&
              type.value !== 'VideoItem' &&
              type.value !== 'Header'
          )
          .map((type, index) => {
            return (
              <MenuItem key={`${index}`} value={type.value}>
                {type.description}
              </MenuItem>
            );
          })}
      </SMBSelect>
      <Button
        sx={{
          marginLeft: {
            xs: 0,
            sm: '1rem'
          },
          marginTop: {
            xs: '1rem',
            sm: '0'
          },
          minWidth: {
            xs: 'auto',
            sm: '14rem'
          }
        }}
        disabled={!selectedType}
        variant="contained"
        startIcon={<Add />}
        onClick={() => {
          const randomNumber = getRandomNegativeNumber();
          handleAddSectionType({
            ...DEFAULT_SECTION,
            name: '',
            // Negative numbers will still create a new record, but are distinct so we can use them on the frontend before the user saves
            customPageSectionId: randomNumber,
            type: selectedType as SectionTypeValue,
            sortOrder: 0, // pass 0 for now, need to be set on parent
            sections: []
          });
        }}
      >
        Add Section Type
      </Button>
    </Box>
  );
};
